<template>
  <div class="memberCenter">
    <header-box />
    <div class="OrderDynamic">
      <div
        style="
          width: 400px;
          margin-left: 100px;
          margin-top: 1rem;
          display: flex;
          align-items: center;
        "
      >
        <div style="margin-right: 0.5rem">订单状态:</div>
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="order.OrderNo"
          style="width: 200px"
        />
        <div style="margin-left: 20px">
          <el-button @click="Thuery" plain>查询</el-button>
        </div>
      </div>
      <div class="tabberBox">
       <from-box :list="orderData" :setBillDetail="setBillDetail" />
      </div>
    </div>
    <!-- 确认订单 -->
    <el-dialog
      title="确认订单"
      :visible.sync="MakeOrder"
      width="40%"
      :before-close="handleClose"
    >
      <div>
        <div class="box">
          <div>
            {{ orderItem.Consignee }} -<span>{{ orderItem.Phone }}</span>
          </div>
          <div>{{ orderItem.Address }}</div>
        </div>
        <div class="details">
          <div>
            <div>交货尺寸:</div>
            <div>
              {{ Content.Det_BoardSize_W }}*{{ Content.Det_BoardSiez_H }}
            </div>
          </div>
          <div>
            <div>交货数量:</div>
            <div>{{ Content.Det_Num }}pcs</div>
          </div>
          <div>
            <div>set数:</div>
            <div>{{ Content.set }}</div>
          </div>
          <div>
            <div>下单型号:</div>
            <div>{{ orderItem.Model }}</div>
          </div>
          <div>
            <div>面积:</div>
            <div>{{ Content.Area }}平方米</div>
          </div>
          <div>
            <div>拼板款数:</div>
            <div>{{ Content.Det_Pmodels }}</div>
          </div>
          <div>
            <div>板材类型:</div>
            <div>{{ Content.Det_BoardType }}</div>
          </div>
          <div>
            <div>板材供应商:</div>
            <div>{{ Content.Det_BoardSupplier }}</div>
          </div>
          <div>
            <div>成品外层铜厚:</div>
            <div>{{ Content.Det_Copper_out }}oz</div>
          </div>
          <div>
            <div>阻焊颜色:</div>
            <div>{{ Content.Det_ZHcolor }}</div>
          </div>
          <div>
            <div>阻焊覆盖:</div>
            <div>{{ Content.coverText }}</div>
          </div>
          <div>
            <div>表面处理:</div>
            <div>{{ Content.Det_Surface }}</div>
          </div>
          <div>
            <div>测试:</div>
            <div>{{ Content.Det_TestMethod }}</div>
          </div>
          <div>
            <div>确认生产稿:</div>
            <div>{{ Content.draftText }}</div>
          </div>
          <div>
            <div>最小线宽/线距:</div>
            <div>{{ Content.Det_LineSpacing }}mil</div>
          </div>
          <div>
            <div>最小孔径:</div>
            <div>{{ Content.aperture }}</div>
          </div>
          <div>
            <div>成型方式:</div>
            <div>{{ Content.Det_MouldManner }}</div>
          </div>
          <div>
            <div>订单号/物料编号:</div>
            <div>{{ Content.TorderNo }}</div>
          </div>
          <div>
            <div>收据/送货单:</div>
            <div>{{ Content.receiptText }}</div>
          </div>
          <div>
            <div>接受打叉板:</div>
            <div>{{ Content.isBreakBoard == 1 ? "接受" : "不接受" }}</div>
          </div>
          <div>
            <div>特殊工艺:</div>
            <div>
              {{ Content.Det_IsHalfHole == 0 ? "" : "半孔"
              }}{{ Content.Det_IsBGA == 0 ? "" : "BGA"
              }}{{ Content.Det_IsImp == 0 ? "" : "阻抗" }}
            </div>
          </div>
          <div>
            <div>接受标准:</div>
            <div>{{ Content.standardText }}</div>
          </div>
          <div>
            <div>发票信息:</div>
            <div>{{ Content.invoiceText }}</div>
          </div>
        </div>
        <div style="display: flex; margin-top: 1rem">
          <div style="width: 20%">优惠券:</div>
          <el-select
            style="width: 80%"
            v-model="region"
            placeholder="请选择优惠券"
          >
            <el-option
              class="optionBox"
              v-for="(item, index) in coupons"
              :key="index"
              :label="`￥${item.CouponDto.Money}`"
              :value="item.CouponDto.Money"
            >
              <div class="itemBox">
                <div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      border-bottom: 1px dashed #999;
                    "
                  >
                    <div>有效时间:{{ item.EndTime }}</div>
                    <div>￥{{ item.CouponDto.Money }}</div>
                  </div>
                  <div>
                    满{{ item.CouponDto.Threshold }}减{{ item.CouponDto.Money }}
                  </div>
                </div>
              </div>
            </el-option>
          </el-select>
        </div>
        <!-- 订单备注 -->
        <div class="TheOrder">
          <div style="color: #000; width: 20%">订单备注:</div>
          <div style="width: 80%">
            <el-input
              type="textarea"
              resize="none"
              :rows="2"
              placeholder="请输入内容"
              v-model.trim="textarea"
            ></el-input>
          </div>
        </div>
        <div style="display: flex; margin-top: 1rem">
          <div style="width: 20%">快递方式:</div>

          <el-select
            style="width: 80%"
            v-model="CourierChoose"
            @change="orderChange"
            placeholder="请选择快递公司"
          >
            <el-option
              v-for="(item, index) in CourierArray"
              :key="index"
              :label="item.value"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <div style="display: flex; margin-top: 1rem">
          <div style="width: 20%">快递费:</div>
          <div style="width: 80%">￥{{ CourierFees }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="MakeOrder = false">取 消</el-button>
        <el-button type="primary" @click="orderObj">确定支付</el-button>
      </span>
    </el-dialog>
    <!-- 支付 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span class="boxflex">
        <div style="margin-right: 0.5rem">支付密码:</div>
        <el-input
          show-password
          style="width: 200px"
          v-model="password"
          placeholder="请输入支付密码"
        ></el-input>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(dialogVisible = false), (password = '')"
          >取 消</el-button
        >
        <el-button type="primary" @click="orderPay">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import headerBox from "../../components/box/headerbox.vue";
import fromBox from "../../components/box/fromBox.vue";
import { address } from "../../api/http/address";
import { getOrderApi } from "../../api/http/order";
export default {
  components: {
    headerBox,
    fromBox
  },
  data() {
    return {
      CourierChoose: "1", //快递方式
      CourierFees: 0, //快递费用
      textarea: "", //订单备注
      CourierArray: [
        { label: "1", value: "联昊通速运" },
        { label: "2", value: "速尔速运" },
        { label: "3", value: "顺丰速运" },
        { label: "4", value: "安能速运" },
      ], //快递数组
      MakeOrder: false, //参数详情
      region: 0, //优惠券
      coupons: [], //优惠卷数组
      orderItem: "", //选中对象
      Content: "", //选中对象的板材参数
      dialogVisible: false, //支付弹窗
      password: "", //支付密码
      orderData: [], //订单列表数组
      order: {
        states: `1,2 `,
        stategroup: "1",
        ordertypes: "2",
        OrderNo: "",
        invoicetype: "0",
        page: 1,
        size: 20,
      },
    };
  },
  created() {
    this.getOrderLis();
  },
  methods: {
        // 子组件调用方法
    setBillDetail() {
      this.getOrderLis();
    },
    // 查询
    Thuery() {
      this.getOrderLis();
    },
    // 快递费计算
    orderChange(e) {
      let obj = {
        Det_BoardThickness: this.Content.Det_BoardThickness,
        Area: this.Content.Area,
        kdtype: this.CourierChoose,
        Province: this.orderItem.Province,
      };

      address
        .calculateFreight(obj)
        .then((res) => {
          let { data } = res.data;
          this.CourierFees = data;
        })
        .catch();
    },
    // 优惠券
    orderLisr(e) {
      this.MakeOrder = true;
      this.orderItem = e;
      this.Content = JSON.parse(e.OrderGoodsDtos[0].Content);
      let params = {
        orderid: e.Id,
        isexpire: false,
        isused: false,
        page: 1,
        size: 30,
      };
      getOrderApi.getCouponMylist(params).then((res) => {
        this.coupons = res.data.data;
        this.orderChange();
      });
    },
    // 订单
    orderObj() {
      this.MakeOrder = false;
      this.dialogVisible = true;
    },
    // 叉号取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 确认支付
    orderPay() {
      let expressCompany = "";
      for (let i = 0; i < this.CourierArray; i++) {
        if (this.CourierChoose == this.CourierArray[i].label) {
          expressCompany = this.CourierArray[i].value;
        }
      }
      let params = {
        orderId: this.orderItem.Id,
        password: this.password,
        payType: 2,
        userCouponId: this.region,
        remark: this.textarea,
        freight: this.CourierFees,
        expressCompany,
      };
      getOrderApi.getPay(params).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: "支付成功！！",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
        this.dialogVisible = false;
      });
    },
    // 取消订单
    confirm(e) {
      let params = {
        orderId: e,
        remark: "",
      };
      getOrderApi.getOrderCancel(params).then((res) => {
        if (res.data.code == 200) {
          this.getOrderLis();
          this.$message({
            message: "取消成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "取消失败",
            type: "error",
          });
        }
      });
    },
    // 订单列表
    getOrderLis() {
      getOrderApi.getOrderLlist(this.order).then((res) => {
        this.orderData = res.data.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.TheOrder {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}
.optionBox {
  height: 80px;
  .itemBox {
    margin: 5px;
    padding: 5px;
    height: 70px;
    background: #fff;
  }
}
.details {
  height: 300px;
  overflow-y: scroll;

  div {
    display: flex;
    justify-content: space-between;
    div {
      padding: 5px;
    }
  }
}
.box {
  border-bottom: 0.1rem solid #999;
}
.boxflex {
  display: flex;
  align-items: center;
}
.flexBox {
  display: flex;
  justify-content: space-evenly;
}
.memberCenter {
  background-color: #fff;
  .OrderDynamic {
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    border: 1px solid #eee;
  }
  .tabberBox {
    width: 90%;
    margin: auto;
    margin-top: 1rem;
    .tabelHeader {
      background-color: #eee;
      display: flex;
      div {
        flex: 1;
        padding: 5px;
        text-align: center;
      }
    }
    .tabelFrom {
      display: flex;
      margin-top: 1rem;
      box-shadow: 0 5px 5px #999;
      border-bottom: 1px solid #999;
      padding-bottom: 10px;
      height: 50px;
      align-items: center;
      div {
        flex: 1;
        text-align: center;
        padding: 5px;
      }
      img {
        width: 50px;
        height: 50px;
        border-radius: 5px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/my/memberCenter.vue